// Latency markers. Kept in case we want a dev HUD later — the voice client
// records them on every turn but nothing in the modal renders them by default.

export const now = () => performance.now();

export function newTurn() {
    return {
        id: Math.random().toString(36).slice(2, 9),
        markers: {}
    };
}

export function afterPaint() {
    return new Promise((resolve) => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve(performance.now()));
        });
    });
}
